import {Body, Container, Desc, Illustration, Logo, Title} from "./style";
import {LogoIcon} from "../../components/Header";
import {useApp} from "../../contexts/app";

export default function NotFound(props: any) {
    const {T} = useApp();

    return (
        <Container>
            <Logo>
                <LogoIcon/>
            </Logo>
            <Body>
                <Illustration/>
                <Title>{T('Oops!')}</Title>
                <Desc>{T('The link is not available.')}</Desc>
            </Body>
        </Container>
    );
}
